module.exports = __webpack_public_path__ + "img/search-movil.25c6c125.svg";